var _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruisingShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#007A87"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#001024",
    strokeOpacity: 0.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3545,
    cy: 10.9532,
    r: 0.29984,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1543,
    cy: 10.9532,
    r: 0.29984,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.959,
    cy: 10.9532,
    r: 0.29984,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7549,
    cy: 10.9532,
    rx: 0.299841,
    ry: 0.29984,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86719 21.0474C9.36692 21.3472 11.4758 21.767 13.5147 21.0474C16.0634 20.1479 17.4126 20.4477 19.0618 21.1973C20.7109 21.9469 22.6598 21.3472 23.2595 21.0474",
    stroke: "white",
    strokeWidth: 0.495833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86719 23.0469C9.36692 23.3468 11.4758 23.7665 13.5147 23.0469C16.0634 22.1474 17.4126 22.4472 19.0618 23.1968C20.7109 23.9464 22.6598 23.3468 23.2595 23.0469",
    stroke: "white",
    strokeWidth: 0.495833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7225 21.4953L9.17383 15.7983L11.8724 14.2991M16.0702 12.0503V17.2975M16.0702 12.0503L11.8724 14.2991M16.0702 12.0503L20.2679 14.2991M20.4178 21.4953L22.9665 15.7983L20.2679 14.2991M11.8724 14.2991V9.15186H13.9713H18.169H20.2679V14.2991",
    stroke: "white",
    strokeWidth: 0.495833
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruisingShip);
export default __webpack_public_path__ + "static/media/cruising-ship.93566da7c5bbe089d3047ff67158a0bc.svg";
export { ForwardRef as ReactComponent };